import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLoginComponent } from './presentacion/page-login/page-login.component';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from './presentacion/components/login/login.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HeaderComponent } from './presentacion/components/header/header.component';
import { MenuComponent } from './presentacion/component/menu/menu.component';
import { AccordionComponent } from './presentacion/component/accordion/accordion/accordion.component';
// import { RouterModule } from '@angular/router';
import { CambiaContrasenaComponent } from './presentacion/components/cambiaContrasena/cambiaContrasena.component';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatBadgeModule} from '@angular/material/badge';
import {OverlayModule} from '@angular/cdk/overlay';
import { MatTreeModule} from '@angular/material/tree';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { TabViewModule } from 'primeng/tabview';
import { TabsModule } from 'primeng/tabs';
import { CustomReuseStrategy } from './presentacion/components/custom-reuse.strategy';

@NgModule({
  declarations: [PageLoginComponent, LoginComponent, HeaderComponent, MenuComponent,AccordionComponent,CambiaContrasenaComponent],
  imports: [
    CommonModule,SharedModule,FormsModule,ReactiveFormsModule,RouterModule,MatButtonModule, MatMenuModule, MatIconModule,
    MatBadgeModule, MatButtonModule, MatIconModule, OverlayModule,MatTreeModule,PasswordModule,DividerModule,TabViewModule, TabsModule
  ],
  exports:[PageLoginComponent,HeaderComponent],//para que sea visible en todo los modulos

  providers: [
  { provide: RouteReuseStrategy, useClass: CustomReuseStrategy }
]
})
export class CoreModule { }
